module.exports = __webpack_public_path__ + "img/head.0451bb5d.png";